import React, { Component } from "react";

export default class Skills extends Component {
  render() {
    return (
      <main id="home">
        <h1 className="lg-heading">
          My <span className="text-secondary">Skills</span>
        </h1>
        <div>
          <div>
            <h4>Programming languages</h4>
            <ul>
              <li>Javascript(Typescript)</li>
              <li>Java</li>
              <li>C#</li>
            </ul>
          </div>
          <div>
            <h4>Database</h4>
            <ul>
              <li>MongoDB</li>
              <li>MySQL</li>
            </ul>
          </div>
          <div>
            <h4>Technologies</h4>
            <ul>
              <li>React.js/Redux</li>
              <li>Node.js</li>
              <li>Express.js</li>
              <li>REST API</li>
              <li>HTML</li>
              <li>CSS</li>
              <li>Vue.js</li>
              <li>Docker</li>
              <li>NGINX</li>
              <li>Spring boot</li>
              <li>Game Development</li>
            </ul>
          </div>
          <div>
            <h4>Tools</h4>
            <ul>
              <li>Eclipse</li>
              <li>Unity 3D</li>
              <li>Blender</li>
              <li>Jasper iReport</li>
            </ul>
          </div>
        </div>
      </main>
    );
  }
}
